import { ShopifyStorefrontMoneyV2 } from '@/types'

export const formatPrice = (
  money: number | ShopifyStorefrontMoneyV2,
): string => {
  const amount = typeof money === 'number' ? money : money.amount
  return ['$', amount.toString().replace(/\.0$/, '')].join('')
}
